/**
 * Sage Client Configuration
 * ─────────────────────────────────────────────────────────────────────────────
 * Single source of truth for all Sage client-side constants.
 * Import from here — never hardcode values in components.
 * ─────────────────────────────────────────────────────────────────────────────
 */

/** SSE streaming endpoint */
export const SAGE_STREAM_URL = "/api/sage/stream";

/** localStorage key for session persistence */
export const SAGE_SESSION_KEY = "sage-session-id";

/** Response modes */
export type ResponseMode = "concise" | "standard" | "detailed";

export const RESPONSE_MODE_LABELS: Record<ResponseMode, string> = {
  concise: "Brief",
  standard: "Normal",
  detailed: "Detailed",
};

/** Lola & Ber booking / contact URL */
export const LB_CONTACT_URL = "https://lolandberretreats.com/work-with-me/";

/** Feature flags */
export const FEATURE_SUGGESTED_QUESTIONS = true;
export const FEATURE_RESPONSE_MODE = true;

/** Panel sizing — adaptive height */
export const PANEL_MAX_VH_DESKTOP = 94;   // cap at 94vh on desktop
export const PANEL_MAX_VH_MOBILE  = 90;   // mobile drawer stays full-height

/** Adaptive height breakpoints (desktop floating panel, in px) */
export const PANEL_HEIGHT_EMPTY   = 720;  // greeting + input + suggested questions
export const PANEL_HEIGHT_PER_MSG = 130;  // estimated px added per message pair
export const PANEL_HEIGHT_MIN     = 480;  // never shrink below this
export const PANEL_HEIGHT_MAX_PX  = 1100; // hard px cap before switching to vh cap

/** Bottom offset so panel floats above the trigger button */
export const PANEL_BOTTOM_OFFSET  = 80;   // px from viewport bottom (clears FAB)

/** Brand colors */
export const SAGE = "#47825F";
export const SAGE_LIGHT = "#6aaa84";
export const SAGE_MUTED = "#e8f2ec";
